import React from 'react';
import './AboutUs.css';
import aboutUsImage from '../../assets/about-us.jpg'; // Make sure this path exists

const AboutUs: React.FC = () => {
  return (
    <section id="about" className="about-us-section section">
      <div className="about-container">
        <div className="about-image-container">
          <img src={aboutUsImage} alt="JSW Team" className="about-us-photo" />
        </div>
        
        <div className="about-content">
          <h2 className="about-title">關於我們</h2>
          <div className="about-text">
            <p>JSW Studio 於2023年成立，並致力推廣香港街頭健身及徒手健身。我們相信無論兒童、青少年或成年人均擁有追求健康的身體、積極的生活方式及追求夢想的權利。</p>
            <p>JSW Studio是香港首間為不同對象提供多元化課程的街頭及徒手健身工作室，課程包括街頭健身技巧訓練、體能訓練以及兒童健體訓練等等。</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;